import { computed } from "vue";
import { useFdiAuth } from "./use-fdi-auth";

export function useFdiBasket() {
    const { getCurrentToken } = useFdiAuth();

    const basketId = computed(() => {
        const token = getCurrentToken();
        return token?.basketId;
    });

    const getBasketId = () => {
        return basketId.value;
    };

    return {
        basketId,
        getBasketId,
    };
}
